import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {  handleUserLevelAccessPermissions, getFormattedDate,changeDateFormat,isEndDateGreater} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {urbanDistrictIndexReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';


function UrbanDistrictIndexReport() {

     
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const [isDivision, setIsDivision] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [buttonAccess, setButtonAccess] = useState(false);
  const storedLanguage = localStorage.getItem('language');
  const today = new Date();
  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };



  useEffect(() => {
   const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)
    if (level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
        setIsDivision(true);
    }
}, []);


//handle excel sheet ***************
const handleGenerateExcel = () => {
  if (!startDate || !endDate) {
    toast.error('Please select the date range', messages.COLOR_RED);
    return;
  }
      
 if(!isEndDateGreater(startDate,endDate)){
    toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
    return;
  }

   showLoading(true);
   let sDate= getFormattedDate(startDate)
   let eDate= getFormattedDate(endDate)
  const payload = {
      fromDate: sDate,
      toDate: eDate,
  };

// POST request to API
axios
    .post(`${API_URL}api/price/getUrbanDistrictIndex`, payload, config)
    .then((response) => {
        const reportData = response.data;
         if(reportData.status){
             downloadReport(reportData.data[0].GroupCodes,sDate,eDate)
         }else{
          toast.error('Data is not found', messages.COLOR_RED);
         }
        
    })
    .catch((error) => {
        console.error('API Error:', error);
     }).finally(()=>{
      showLoading(false);
    });
}



const formatGrossValue = (value) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(2);
};

const downloadReport=(allData,sDate,eDate)=>{

     const firstRowdata=allData[0];
     const headers = Object.keys(firstRowdata);
     const headerEnglishColumns = headers.map(key => firstRowdata[key]);

    const [firstObject, ...restOfArray] = allData;
          const additionalData = restOfArray.map(item => [
            
              item.distMonth,
            item.strDate,
             item.districtName,
            formatGrossValue(item.all_index),
            formatGrossValue(item.food_beverages_and_tobacco_index),
            formatGrossValue(item.cereals_and_products_index),
            formatGrossValue(item.wheat_flour_index),
            formatGrossValue(item.rice_arwa_index),
            formatGrossValue(item.gram_whole_index),
            formatGrossValue(item.maize_index),
            formatGrossValue(item.pulses_and_products_index),
            formatGrossValue(item.arhar_dal_index),
            formatGrossValue(item.urd_dal_index),
            formatGrossValue(item.masur_dal_index),
            formatGrossValue(item.pea_dal_index),
            formatGrossValue(item.moong_dal_index),
            formatGrossValue(item.gram__dal_index),
            formatGrossValue(item.soyabeenbari_index),
            formatGrossValue(item.milk_and_milk_products_index),
            formatGrossValue(item.milk_index),
            formatGrossValue(item.ghee_index),
            formatGrossValue(item.oils_and_fats_index),
            formatGrossValue(item.mustard_oil_index),
            formatGrossValue(item.vanaspati_ghee_index),
            formatGrossValue(item.meats_and_fish_and_eggs_index),
            formatGrossValue(item.goat_meat_index),
            formatGrossValue(item.fish_rohu_index),
            formatGrossValue(item.eggs_index),
            formatGrossValue(item.vegetables_index),
            formatGrossValue(item.potato_index),
            formatGrossValue(item.tomato_index),
            formatGrossValue(item.onion_index),
            formatGrossValue(item.brinjal_index),
            formatGrossValue(item.chilli_index),
            formatGrossValue(item.fruits_and_dry_fruits_index),
            formatGrossValue(item.apple_index),
            formatGrossValue(item.banana_index),
            formatGrossValue(item.mango_index),
            formatGrossValue(item.groundnut_index),
            formatGrossValue(item.dry_fruit_coconut_copra_index),
            formatGrossValue(item.sugar_and__gur_etc_index),
            formatGrossValue(item.sugar_index),
            formatGrossValue(item.gur_index),
            formatGrossValue(item.condiments_and_spices_index),
            formatGrossValue(item.corriander_whole_index),
            formatGrossValue(item.dry_chillies_whole_index),
            formatGrossValue(item.turmeric_whole_index),
            formatGrossValue(item.salt_powder_index),
            formatGrossValue(item.garam_masala_index),
            formatGrossValue(item.prepared_meal_and_refresment_index),
            formatGrossValue(item.prepared_sweets_index),
            formatGrossValue(item.biscuits_index),
            formatGrossValue(item.sev_besan_index),
            formatGrossValue(item.non_alchohlic_beverages_index),
            formatGrossValue(item.tea_leaf_index),
            formatGrossValue(item.tea_cups_index),
            formatGrossValue(item.cold_drink_index),
            formatGrossValue(item.pan_supari_and_tabacco_beverages_index),
            formatGrossValue(item.average_of_pan_leaf_sada_and__supari_index),
            formatGrossValue(item.bidi_index),
            formatGrossValue(item.cigratte_index),
            formatGrossValue(item.tobaco_chewing_leaf_index),
            formatGrossValue(item.country_liquor_index),
            formatGrossValue(item.fuel_and_light_index),
            formatGrossValue(item.electricity_index),
            formatGrossValue(item.lpg_index),
            formatGrossValue(item.firewoods_index),
            formatGrossValue(item.kerosene_index),
            formatGrossValue(item.match_box_index),
            formatGrossValue(item.candle_index),
            formatGrossValue(item.housing_index),
            formatGrossValue(item.house_rent_index),
            formatGrossValue(item.average_of_raj_and_unskilled_labour_index),
            formatGrossValue(item['water_charges/tax_index']),
            formatGrossValue(item.clothing_and_bedding_and_footwear_index),
            formatGrossValue(item.clothing_and_bedding_index),
            formatGrossValue(item.cloth_shirt_index),
            formatGrossValue(item.sari_index),
            formatGrossValue(item.dhoti_mardani_index),
            formatGrossValue(item.hosiery_baniyan_index),
            formatGrossValue(item.bedsheet_index),
            formatGrossValue(item.footwear_index),
            formatGrossValue(item.leather_shoes_index),
            formatGrossValue(item.leather_sandalsladies_index),
            formatGrossValue(item.rubber_pvc_footwear_chappal_index),
            formatGrossValue(item.miscellaneous_index),
            formatGrossValue(item.education_index),
            formatGrossValue(item.tutionfees_index),
            formatGrossValue(item.register_index),
            formatGrossValue(item.newspapers_hindi_dainik_index),
            formatGrossValue(item.medical_care_index),
            formatGrossValue(item.crocin_index),
            formatGrossValue(item.atin_50_index),
            formatGrossValue(item.daynil_index),
            formatGrossValue(item.benadryl_cough_syrup114ml_index),
            formatGrossValue(item.doctors_fee_at_clinic_index),
            formatGrossValue(item.blood_test_index),
            formatGrossValue(item.recreation_and_amusement_index),
            formatGrossValue(item.cinema_ticket_index),
            formatGrossValue(item.cabel_tv_rent_index),
            formatGrossValue(item.colour_tv_index),
            formatGrossValue(item.personal_care_and_effects_index),
            formatGrossValue(item.bathing_soap_index),
            formatGrossValue(item.hair_oil_index),
            formatGrossValue(item.toothpaste_index),
            formatGrossValue(item.telcom_powder_index),
            formatGrossValue(item.shaving_blades_index),
            formatGrossValue(item.household_and_requisties_index),
            formatGrossValue(item.torch_index),
            formatGrossValue(item.agarbati_index),
            formatGrossValue(item.electric_bulb_index),
            formatGrossValue(item.tailor_index),
            formatGrossValue(item.barber_index),
            formatGrossValue(item.grinding_index),
            formatGrossValue(item.washing_shop_index),
            formatGrossValue(item.single_bed_index),
            formatGrossValue(item.thali_index),
            formatGrossValue(item.ceilling_fan_index),
            formatGrossValue(item.unskilled_labour_index),
            formatGrossValue(item.mobile_phone_handset_index),
            formatGrossValue(item.transport_and_communication_index),
            formatGrossValue(item.telephone_charges_index),
            formatGrossValue(item.registerd_letter_10_gms_index),
            formatGrossValue(item.petrol_index),
            formatGrossValue(item.railway_fare_index),
            formatGrossValue(item.bus_fare_index),
            formatGrossValue(item.car_index),
            formatGrossValue(item.motor_cycle_index),
            formatGrossValue(item.others_index),
            formatGrossValue(item.gold_index),
            formatGrossValue(item.silver_index)
          ]);

          let redGroup = ['समस्त','खाद्य, पेय द्रव्य और तम्बाकू','अनाज और उत्पाद', 'दालें एवं उत्पाद', 'दूध एवं दूग्ध उत्पाद',
            'तेल व स्निग्ध पदार्थ','माँस, मछली व अण्डा','तरकारी','फल एवं शुष्क फल','चीनी, गुड़ आदि','मसाले','तैयार भोजन और अल्पाहार','अमादक पेय',
          'पान,   सुपारी, तम्बाकू व मादक पेय','ईंधन व प्रकाश','आवास','वस्त्र, बिस्तर एवं जूते','वस्त्र और बिस्तर',
          'जूते','विविध','शिक्षा','चिकित्सा','मनोरंजन आदि','व्यक्तिगत देख-रेख एवं चल सम्पत्ति','घरेलू और आवश्यकताएं',
          'यातायात और संचार','अन्य ' ]
  
          const excelObjectData = {
            fileName: "PRIUrbanDistrictIndex",
            fileType: 'xls',
            sheetName: 'PRIUrbanDistrictIndex',
            firstRowMergeCells: "A1:J1",
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: "A2:J2",
            secondRowText: `Price Urban District Index (${sDate}-${eDate}) (Base Year 2011-12=100)`,
            headerEnglishColumns: headerEnglishColumns,
            redGroup:redGroup
          };
  
          excelObjectData.excelRowData = [...additionalData];
          urbanDistrictIndexReport(excelObjectData);
}



  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.DISTRICT_INDEX_REPORT : priceTitle.en.DISTRICT_INDEX_REPORT }} />
              
                    </h4>
                    <div className="row align-items-center">
                        {isDivision && (
                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                                <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                            </div>
                        )}

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">From Date</label>
                            <DatePicker
                                className="form-control calendar_icon"
                                selected={startDate}
                                onChange={(e) => { setStartDate(e) }}
                                dateFormat="MMM yyyy"
                                showMonthYearPicker
                                placeholderText="Select month"
                                maxDate={today}
                            />
                        </div>


                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">To Date</label>
                            <DatePicker
                                className="form-control calendar_icon"
                                selected={endDate}
                                onChange={(e) => { setEndDate(e) }}
                                dateFormat="MMM yyyy"
                                showMonthYearPicker
                                placeholderText="Select month"
                                maxDate={today}
                            />
                        </div>


                        <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default UrbanDistrictIndexReport